import { FaFacebookF, FaInstagram, FaTiktok, FaXTwitter } from "react-icons/fa6";

const SOCIAL_META = [
  {
    key: "facebook",
    label: "Facebook",
    url: "https://www.facebook.com/profile.php?id=61576449431492",
    Icon: FaFacebookF,
    accentClass:
      "hover:border-sky-300 hover:text-sky-700 hover:bg-sky-50 dark:hover:border-sky-700 dark:hover:text-sky-300 dark:hover:bg-sky-950/30",
  },
  {
    key: "instagram",
    label: "Instagram",
    url: "https://www.instagram.com/apparify/",
    Icon: FaInstagram,
    accentClass:
      "hover:border-pink-300 hover:text-pink-700 hover:bg-pink-50 dark:hover:border-pink-700 dark:hover:text-pink-300 dark:hover:bg-pink-950/30",
  },
  {
    key: "x",
    label: "X",
    url: "https://x.com/ApparifyShop",
    Icon: FaXTwitter,
    accentClass:
      "hover:border-neutral-400 hover:text-neutral-900 hover:bg-white dark:hover:border-neutral-500 dark:hover:text-neutral-100 dark:hover:bg-neutral-900",
  },
  {
    key: "tiktok",
    label: "TikTok",
    url: "https://www.tiktok.com/@apparify1",
    Icon: FaTiktok,
    accentClass:
      "hover:border-emerald-300 hover:text-emerald-700 hover:bg-emerald-50 dark:hover:border-emerald-700 dark:hover:text-emerald-300 dark:hover:bg-emerald-950/30",
  },
];

function normalizeUrl(value) {
  const normalized = String(value || "").trim();
  if (!normalized) return null;
  const candidate = /^https?:\/\//i.test(normalized) ? normalized : `https://${normalized}`;

  try {
    const parsed = new URL(candidate);
    return parsed.toString();
  } catch {
    return null;
  }
}

export default function SocialIconLinks({
  socialLinks = {},
  brandName = "Apparify",
  variant = "footer",
}) {
  const items = SOCIAL_META
    .map((entry) => ({
      ...entry,
      url: entry.url || normalizeUrl(socialLinks?.[entry.key]),
    }))
    .filter((entry) => entry.url);

  if (items.length === 0) return null;

  const variantClasses = variant === "minimal"
    ? {
      container: "flex flex-wrap gap-1",
      link:
        "inline-flex h-9 w-9 items-center justify-center rounded-full text-neutral-500 transition hover:bg-neutral-200/70 hover:text-neutral-950 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neutral-900/20 dark:text-neutral-400 dark:hover:bg-neutral-800 dark:hover:text-white dark:focus-visible:ring-neutral-100/20",
      icon: "text-[14px]",
    }
    : variant === "panel"
    ? {
      container: "flex flex-wrap gap-2.5",
      link:
        "inline-flex h-11 w-11 items-center justify-center rounded-2xl border border-neutral-200 bg-white text-neutral-600 shadow-sm transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neutral-900/10 active:scale-[0.98] dark:border-neutral-700 dark:bg-neutral-900 dark:text-neutral-300 dark:focus-visible:ring-neutral-100/10",
      icon: "text-[16px]",
    }
    : {
      container: "flex flex-wrap gap-2.5",
      link:
        "inline-flex h-10 w-10 items-center justify-center rounded-2xl border border-neutral-200 bg-white/80 text-neutral-600 shadow-sm transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neutral-900/10 active:scale-[0.98] dark:border-neutral-700 dark:bg-neutral-900 dark:text-neutral-300 dark:focus-visible:ring-neutral-100/10",
      icon: "text-[15px]",
    };

  return (
    <div className={variantClasses.container}>
      {items.map(({ key, label, Icon, url, accentClass }) => (
        <a
          key={key}
          href={url}
          target="_blank"
          rel="noreferrer noopener"
          aria-label={`Visit ${brandName} on ${label}`}
          title={label}
          className={`${variantClasses.link} ${variant === "minimal" ? "" : accentClass}`}
        >
          <Icon className={variantClasses.icon} aria-hidden="true" />
        </a>
      ))}
    </div>
  );
}
